module.exports = __webpack_public_path__ + "static/img/news3.f5700b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news4/news3.jpg
// module id = w5lM
// module chunks = 1